import axios from 'axios';
import toast from 'react-hot-toast';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api/v1',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Enable sending cookies
});

// Request interceptor to handle file uploads
api.interceptors.request.use(
  (config) => {
    // Automatically set Content-Type for FormData (file uploads)
    if (config.data instanceof FormData) {
      // config.headers['Content-Type'] = 'multipart/form-data';
      // Let the browser set the Content-Type header with the correct boundary
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    console.error('❌ [AXIOS REQUEST ERROR]', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('❌ [AXIOS ERROR]', error);
    console.error('❌ [AXIOS ERROR RESPONSE]', error.response);
    console.error('❌ [AXIOS ERROR MESSAGE]', error.message);
    
    const { response, config } = error;
    
    if (response?.status === 401) {
      // Unauthorized - redirect to login
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
        toast.error('Session expired. Please login again.');
      }
    } else if (response?.status === 403) {
      toast.error('Access denied. You do not have permission for this action.');
    } else if (response?.status >= 500) {
      toast.error('Server error. Please try again later.');
    } else if (response?.data?.message) {
      toast.error(response.data.message);
    } else {
      toast.error('An unexpected error occurred.');
    }
    
    return Promise.reject(error);
  }
);

export default api;
